import Vue from 'vue'
import App from './App.vue'
import router from './router'


import toast from 'components/common/Toast/index'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  loading: require('@/assets/images/loading.png'), // 正在加载时显示的图片路径
  error: require('@/assets/images/error.png'), // 图片加载失败时显示的图片路径
  attempt: 1, // 图片加载失败后重试次数，默认3
})

import { gethotelphone } from "network/home";

import BaiduMap from 'vue-baidu-map'
import { UID } from "@/common/until/const";



Vue.use(BaiduMap, {
  ak: '8CMqeO6Ycasx8jcfi4aZSG6cDMS8mURq'
})

Vue.use(ElementUI);
Vue.use(toast) //执行函数中install方法


Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
